export default function() {
  return {
    TestimonialsList: [],
    totalItems : 0,
    page: 1,
    limit: 8,
    statusInsertTestimonials: [],
    statusUpdateTestimonials: [],
    statusDelTestimonials: []
  }
}
